export default __webpack_public_path__ + "Mask-group-1.267558.svg";